import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { messages } from "./messages";
import {
  applyDocumentLocale,
  readStoredLocale,
  storeLocale,
  translate,
} from "./locale";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [locale, setLocaleState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const initial = readStoredLocale();
    applyDocumentLocale(initial);
    return initial;
  });

  const setLocale = useCallback((next) => {
    if (next !== "en" && next !== "ar") return;
    setLocaleState(next);
    storeLocale(next);
    applyDocumentLocale(next);
  }, []);

  const t = useCallback(
    (key) => translate(messages[locale] || messages.en, key),
    [locale],
  );

  const copy = messages[locale] || messages.en;

  const value = useMemo(
    () => ({ locale, setLocale, t, copy, isRtl: locale === "ar" }),
    [locale, setLocale, t, copy],
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return ctx;
}
